import React from "react";
import { GlobeIcon } from "lucide-react";
import { Section } from "../Section";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { MOCKUP_URL } from "../../data/offer";
export function FinalCTA() {
  return <Section className="bg-navy" data-id="element-165" data-mp="3mrnzk3kjy27x">
      <div className="mx-auto max-w-3xl text-center" data-id="element-166" data-mp="3rslca0msm421">
        <h2 className="text-balance font-display text-[32px] font-bold leading-[1.1] text-white sm:text-5xl" data-id="element-167" data-mp="3rr0m0n7ih79z">
          Ready to organize your articulation planning resources?
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-white/85" data-id="element-168" data-mp="3hw8kx9eq02ag">
          You don't need to recreate every worksheet, activity organizer, or documentation template from scratch. Start
          with a structured educational collection that brings practical planning resources together in one place.
        </p>

        <div className="mt-8 overflow-hidden rounded-[32px] bg-white" data-id="element-169" data-mp="121q3jmgp0oy8">
          <img src={MOCKUP_URL} alt="Pediatric Articulation Clinical Blueprint collection" className="mx-auto h-auto w-full max-w-lg" loading="lazy" data-id="element-170" data-mp="171uoppsjq7us" />
          <div className="px-5 pb-8 sm:px-10" data-id="element-171" data-mp="la296t8rwyd6">
            <p className="font-display text-xl font-bold uppercase leading-tight text-navy" data-id="element-172" data-mp="l9ab9brpeojq">
              Pediatric Articulation Clinical Blueprint™
            </p>
            <p className="mt-1 font-bold text-ink/75" data-id="element-173" data-mp="v0epg99k25di">6 Practical Volumes + 5 Specialized Bonuses</p>
            <p className="mt-4 text-sm font-extrabold uppercase tracking-wide text-ink/70" data-id="element-174" data-mp="7ass7rcqu085">Your price</p>
            <p className="font-display text-7xl font-bold leading-none text-coral" data-id="element-175" data-mp="2bpu6qv6ku9o">
              $27 <span className="text-2xl text-ink/70" data-id="element-176" data-mp="gapityip195u">USD</span>
            </p>
            <div className="mt-6" data-id="element-177" data-mp="bbme6f6ml4ye">
              <CTAButton label="Get the Blueprint now" note="One-time payment · Instant digital access" data-id="element-178" data-mp="bal52g966sjb" />
            </div>
            <Countdown data-id="element-179" data-mp="1rnrt6bu792hk" />
            <p className="mt-5 flex items-center justify-center gap-2 text-sm font-bold text-ink/75" data-id="element-180" data-mp="1mqjgurvqfso8">
              <GlobeIcon className="h-4 w-4 shrink-0 text-sky" aria-hidden="true" data-id="element-181" data-mp="kd3os2be08e4" />
              Currency is converted automatically at checkout
            </p>
          </div>
        </div>
      </div>
    </Section>;
}